var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "map-image" }, [
    _c("div", {
      staticClass: "map-image__sizer",
      staticStyle: { "padding-bottom": "100%" },
    }),
    _c("div", { staticClass: "map-image__image", style: _vm.styleImage }),
    _c("div", { staticClass: "map-image__content" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }